module.exports = __webpack_public_path__ + "img/logo.f209e5f9.png";